import { render } from "./PainelExpande.vue?vue&type=template&id=124d96e8&scoped=true"
import script from "./PainelExpande.vue?vue&type=script&lang=js"
export * from "./PainelExpande.vue?vue&type=script&lang=js"

import "./PainelExpande.vue?vue&type=style&index=0&id=124d96e8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-124d96e8"]])

export default __exports__